const INDIVIDUAL = 'individual'
const CORPORATE = 'corporate'

export default {
    INDIVIDUAL: INDIVIDUAL,
    CORPORATE: CORPORATE
}
